<template>
  <Multiselect
    :class="{ invalid: invalid }"
    v-model="val"
    :options="options"
    placeholder="Selecciona Uno"
    selectLabel="Seleccionar"
    deselectLabel="Deseleccionar"
    selectedLabel="Seleccionado"
    :loading="isLoading"
    @search-change="find"
    :internal-search="false"
    @open="openHandler"
    :disabled="disabled"
  >
    <template slot="singleLabel" slot-scope="props">{{
      props.option.name
    }}</template>
    <template slot="option" slot-scope="props">{{
      props.option.name
    }}</template>
    <span slot="noOptions">Sin resultados</span>
    <span slot="noResult">No hay resultados</span>
  </Multiselect>
</template>

<script>
import { debounce } from "lodash";
import { GeneralService } from "../GeneralService";

export default {
  props: {
    specialty_id: {
      default: undefined
    },
    disabled: {
      default: false
    },
    value: {
      default: undefined
    },
    invalid: {
      default: false
    }
  },
  watch: {
    val(to) {
      if (to == null || to.id == undefined) {
        this.$emit("input", undefined);
      } else {
        this.$emit("input", to.id);
      }
    }
  },
  data() {
    return {
      isLoading: false,
      val: undefined,
      options: []
    };
  },
  created() {
    // this.getList();
  },
  methods: {
    reset() {
      this.options = [];
      this.val = null;
    },
    setValue(specialty) {
      return new Promise(() => {
        GeneralService.getSpecialties({ search: specialty }).then(res => {
          this.options = res.data;
          this.val = res.data[0];
          this.$emit("input", res.data[0].id);
        });
      });
    },
    setValueFromId(reg_id) {
      if (reg_id) {
        this.isLoading = true;
        GeneralService.getSpecialty(reg_id).then(res => {
          this.isLoading = false;
          this.options = [res.data];
          this.val = res.data;
          this.$emit("input", reg_id);
        });
      } else {
        this.val = {};
      }
    },
    openHandler() {
      if (this.options.length == 0) {
        this.getList();
      }
    },
    getList(search) {
      return new Promise(() => {
        GeneralService.getSpecialties({
          search,
          specialty_id: this.specialty_id
        }).then(res => {
          this.options = res.data;
          this.isLoading = false;
        });
      });
    },
    setDefault() {},
    find(search) {
      if (search) this.asyncFind(search, this);
    },
    asyncFind: debounce((search, vm) => {
      vm.isLoading = true;
      vm.getList(search);
    }, 350)
  }
};
</script>

<style scoped>
.invalid {
  border: 1px solid red;
  border-radius: 0.25rem;
}
</style>